const members = document.querySelectorAll('.newsslider');

for( i=0; i< members.length; i++ ) {
  
    members[i].classList.add('newsslider-swiper-container-' + i);

    var slider = new Swiper('.newsslider-swiper-container-' + i +' .newsslider-list' , {
        freeMode: true,
        watchOverflow: true,
        preventClicks: true,
        preventClicksPropagation: true,
        slidesPerView: 1,
        spaceBetween: 16,
        navigation: {
            nextEl: '.newsslider.newsslider-swiper-container-' + i + ' .swiper-button-next',
            prevEl: '.newsslider.newsslider-swiper-container-' + i + ' .swiper-button-prev',
        },
        breakpoints: {
            0: {
                slidesPerView: 1.2,
                spaceBetween: 16,
                centeredSlides: true,
                loop: true
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 16,
                centeredSlides: false,
                loop: false
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 16,
                centeredSlides: false,
                loop: false
            },
            1200: {
                slidesPerView: 4,
                spaceBetween: 16,
                centeredSlides: false,
                loop: false
            }
            
        }
    });

}